import {
  TOGGLE_COLLAPSED_NAV,
  CHANGE_LOCALE,
  SIDE_NAV_STYLE_CHANGE,
  NAV_TYPE_CHANGE,
  TOP_NAV_COLOR_CHANGE,
  HEADER_NAV_COLOR_CHANGE,
  TOGGLE_MOBILE_NAV,
  SWITCH_THEME,
  DIRECTION_CHANGE,
  BTN_COLOR_PRIMARY,
  BTN_COLOR_SECONDARY,
  MENU_COLOR_BG,
  MENU_COLOR_ITEM,
  MENU_COLOR_ITEM_HOVER,
  MENU_COLOR_ITEM_ACTIVE,
  MENU_UPDATE_COLORS
} from '../constants/Theme';
import { THEME_CONFIG } from 'configs/AppConfig'

const initTheme = {
  ...THEME_CONFIG
};
// const initTheme = JSON.parse(localStorage.getItem('user_info')).data.theme

const theme = (state = initTheme, action) => {
  switch (action.type) {
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.navCollapsed
      };
    case SIDE_NAV_STYLE_CHANGE:
      return {
        ...state,
        sideNavTheme: action.sideNavTheme
      };
    case CHANGE_LOCALE:
      return {
        ...state,
        locale: action.locale
      };
    case NAV_TYPE_CHANGE:
      return {
        ...state,
        navType: action.navType
      };
    case TOP_NAV_COLOR_CHANGE:
      return {
        ...state,
        topNavColor: action.topNavColor
      };
    case HEADER_NAV_COLOR_CHANGE:
      return {
        ...state,
        headerNavColor: action.headerNavColor
      };
    case TOGGLE_MOBILE_NAV:
      return {
        ...state,
        mobileNav: action.mobileNav
      };
    case SWITCH_THEME:
      return {
        ...state,
        currentTheme: action.currentTheme
      }
    case DIRECTION_CHANGE:
      return {
        ...state,
        direction: action.direction
      }
    case BTN_COLOR_PRIMARY:
      return {
          ...state,
          btnColorPrimary: action.btnColorPrimary
      }
    case BTN_COLOR_SECONDARY:
      return {
          ...state,
          btnColorSecondary: action.btnColorSecondary
      }
    case MENU_COLOR_BG:
      return {
          ...state,
          bgColorMenu: action.bgColorMenu
      } 
    case MENU_COLOR_ITEM:
      return {
          ...state,
          menuColorItem: action.menuColorItem
      }
    case MENU_COLOR_ITEM_ACTIVE:
      return {
          ...state,
          menuColorItemActive: action.menuColorItemActive
      } 
    case MENU_COLOR_ITEM_HOVER:
      return {
          ...state,
          menuColorItemHover: action.menuColorItemHover
      }
    case MENU_UPDATE_COLORS:
      return {
          ...state,
          menuColorItem:action.menuColorItem,
          menuColorItemHover:action.menuColorItemHover,
          menuColorItemActive:action.menuColorItemActive,
          bgColorMenu:action.bgColorMenu,
      }    

      



    default:
      return state;
  }
};

export default theme